// Lib
import { createSelector } from 'reselect';
import * as Immutable from 'immutable';
import { get } from 'lodash/fp';

// Utils
import { createDeepSelector, createShallowSelector } from '../../../../utils/milanoteReselect/milanoteReselect';

// Selectors
import { getBoardSummariesMapSelector } from '../../../../element/board/summary/boardSummariesSelector';
import { getElements } from '../../../../element/selectors/elementSelector';
import { getGridSize } from '../../../../utils/grid/gridSizeSelector';
import getBoardResultUrl from './getBoardResultUrl';
import { getClosestPermissionIdForElementIdSelector } from '../../../../utils/permissions/permissionsSelector';
import { getCurrentBoardId } from '../../../../reducers/currentBoardId/currentBoardIdSelector';

// Constants

import { ElementType } from '../../../../../common/elements/elementTypes';

const EMPTY_BOARD = Immutable.Map();

const getMatchedElementsSize = get(['matchElementIds', 'length']);

const getResultElement = (state, ownProps) => getElements(state).get(ownProps.result.id);

const getResultBoardSummary = createShallowSelector(
    (state, ownProps) => ownProps.result.id,
    getBoardSummariesMapSelector,
    (id, boardSummariesMap) => boardSummariesMap[id],
);

export const fallbackToBoardSummary = (element, boardSummary) => {
    if (element) return element;

    if (!boardSummary) return EMPTY_BOARD;

    return Immutable.fromJS({
        id: boardSummary.id,
        elementType: ElementType.BOARD_TYPE,
        content: {
            title: boardSummary.title,
            color: boardSummary.color,
        },
    });
};

const boardSummarySelector = () => createDeepSelector(getResultElement, getResultBoardSummary, fallbackToBoardSummary);

// TODO this should be able to be memoised better, if there's any performance issues check here
const boardSearchResultPermissionIdSelector = () => {
    const permissionSelector = getClosestPermissionIdForElementIdSelector();

    return (state, ownProps) => permissionSelector(state, { elementId: ownProps.result.id });
};

export const boardLinkUrlSelector = () =>
    createSelector(
        (state, ownProps) => ownProps.result,
        (state, ownProps) => ownProps.searchQuery,
        boardSearchResultPermissionIdSelector(),
        getCurrentBoardId,
        (result, searchQuery, permissionId, currentBoardId) =>
            getBoardResultUrl({
                result,
                searchQuery,
                permissionId,
                currentBoardId,
            }),
    );

export default () =>
    createSelector(
        (state, ownProps) => ownProps.result,
        boardSummarySelector(),
        boardLinkUrlSelector(),
        getGridSize,
        (matchedBoardResult, board, linkUrl, gridSize, permissionId) => ({
            board,
            linkUrl,
            gridSize,
            score: matchedBoardResult.score,
            resultsCount: getMatchedElementsSize(matchedBoardResult),
            permissionId,
        }),
    );
